import { Injectable } from '@angular/core';

@Injectable()
export class TextHighlightService {

    constructor( ) {
    }

    public getHighlightedText(originalText: string, searchTerm: string) {
        const regex = new RegExp(searchTerm, 'gi');
        return searchTerm
            ? originalText.replace(
                regex,
                (match) => `<span class="text-highlight">${match}</span>`
            )
            : originalText;
    }
}